import { useAuth } from '../auth';

/**
 * Возвращает true, если пользователь имеет доступ к секциям manager/admin
 * (Сотрудники, Товары, Заказы).
 * Основано на isCompanyAdmin или miniappRole === manager/administrator.
 */
export function useCanAccessManagerSections(): boolean {
  const { user } = useAuth();
  return (
    Boolean(user?.isCompanyAdmin) ||
    user?.miniappRole === 'manager' ||
    user?.miniappRole === 'administrator'
  );
}
